import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

const flavourClassName = {
  info: 'tw-bg-cyan-300',
  warning: 'tw-bg-red-300',
};

const layoutClassNames = {
  small: { margin: 'tw-mb-1', text: 'tw-text-s' },
  medium: { margin: 'tw-mb-2', text: 'tw-text-m' },
};

export default function InfoBanner({
  children,
  flavour = 'info',
  size = 'small',
  title,
}) {
  return (
    <div className='tw-mb-6 tw-flex tw-shadow-sm'>
      <div
        className={classNames(
          'tw-h-full tw-w-1 tw-shrink-0 tw-rounded-l-lg',
          flavourClassName[flavour],
        )}
      />
      <div className='tw-flex-1 tw-rounded-r-lg tw-bg-white tw-p-4'>
        <div
          className={classNames(
            'tw-text-l tw-font-semibold tw-text-grey-900',
            layoutClassNames[size]?.margin,
          )}
        >
          {title}
        </div>
        <div
          className={classNames(
            'tw-tracking-wide tw-text-grey-700',
            layoutClassNames[size]?.text,
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

InfoBanner.propTypes = {
  children: PropTypes.node.isRequired,
  flavour: PropTypes.string,
  size: PropTypes.string,
  title: PropTypes.string.isRequired,
};
